<template>
    <div class="formItem" :class="{'formError' : error}">
        <label v-if="!onlyField">{{ label }}
            <span v-if="subLabel"> ({{ subLabel }})</span>
        </label>
        <v-switch
                class="sr-switch"
                :disabled="loading || readonly"
                :readonly="loading || readonly"
                v-model="localValue"
                :label="getInstructions"
        ></v-switch>
    </div>
</template>

<script>
  export default {
    props: {
      default: {
        type: [Boolean, String],
        default: false
      },
      onlyField: {
        type: Boolean,
        default: false
      },
      instructions: {
        type: String,
        default: ''
      },
      error: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      subLabel: {
        type: String,
        default: ''
      },
      value: {
        type: Boolean,
        default: null
      }
    },
    mounted () {
      if (this.value === null) {
        this.$emit('input', Boolean(this.default))
      }
    },
    computed: {
      localValue: {
        get () {
          return this.value === null ? Boolean(this.default) : this.value
        },
        set (newValue) {
          this.$emit('input', newValue)
        }
      },
      getInstructions () {
        if (this.onlyField) {
          return ''
        }

        return this.instructions
      }
    }
  }
</script>

<style scoped>

</style>
